import { jsx as _jsx } from "react/jsx-runtime";
import { getInitials, contrastColor } from '@watchparty/shared';
export default function Avatar({ displayName, avatarUrl, avatarColor = '#5a5a5a', size = 36, style, }) {
    const initials = getInitials(displayName);
    const bg = avatarColor ?? '#5a5a5a';
    const fg = contrastColor(bg);
    const fontSize = size <= 28 ? size * 0.38 : size * 0.35;
    const baseStyle = {
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        ...style,
    };
    if (avatarUrl) {
        return (_jsx("div", { style: baseStyle, children: _jsx("img", { src: avatarUrl, alt: displayName ?? '', style: { width: '100%', height: '100%', objectFit: 'cover' }, onError: (e) => {
                    // If image fails to load, fall back to initials
                    // by hiding the img and showing initials
                    ;
                    e.target.style.display = 'none';
                } }) }));
    }
    return (_jsx("div", { style: {
            ...baseStyle,
            background: bg,
        }, children: _jsx("span", { style: {
                fontFamily: 'var(--font-family-body)',
                fontSize,
                fontWeight: 700,
                color: fg,
                lineHeight: 1,
            }, children: initials }) }));
}
